// src/pages/Home.js
import React from 'react';
import Login from './Login'; // Adjust the path as necessary
const BASE_URL = process.env.REACT_APP_BASE_URL;
function Home() {
  return (
    <div >
      
            <img src={`${BASE_URL}/images/prasarana.png`} alt="Logo" className="img-fluid logo" />
          
      <h1>Welcome to the Training Management System</h1>
      <p>Please login to continue.</p>
      <Login />
    </div>
  );
}

export default Home;


